import { ACCEPT, GATED, HIDDEN, NEW, READ, REJECT } from '@src/components/Cards/constants'

export type CheckType =
  | 'spellcheck'
  | 'language'
  | 'plagiarism'
  | 'freemiumPlagiarism'
  | 'wtai'
  | 'rules'
  | 'classifiers'

export interface GrammarReplacement {
  value: string
}

export interface Citation {
  as: string
  matched: string
  source: string
}

export interface PlagiarismGlimpse {
  glimpseId?: string
  submissionId?: string
}

export interface PlagiarismReplacement {
  cite: Citation
  similarity: number
}

export interface CheckSummary extends Pick<PlagiarismGlimpse, 'submissionId'> {
  overallMatchPercentage?: number
}

export type CommentState =
  | typeof NEW
  | typeof READ
  | typeof ACCEPT
  | typeof REJECT
  | typeof HIDDEN
  | typeof GATED

export type Replacement = GrammarReplacement | PlagiarismReplacement

export interface CheckMetadata extends PlagiarismGlimpse {
  id: string
  type: CheckType
  rule: string
  category: string
  offset: number
  length: number
  message: string
  errorText: string
  replacements: Replacement[]
  state: CommentState
  issueType: string
  analytics?: CheckMetadataAnalytics
  overallMatchPercentage?: number
}

export interface CheckMetadataAnalytics {
  model_name: string
  model_type: string
  label: string
  score: number
  sentence_start: number
  sentence_end: number
}

export interface Check {
  finished?: boolean
  type: CheckType
  count: number
  status?: Status // This is set when checks fail. Adding the type to capture that.
  overallMatchPercentage?: number
}

export interface CheckWithMetadata extends Check {
  metadata: CheckMetadata[]
  summary?: CheckSummary
}

export const RUNNING = 'RUNNING'
export const COMPLETED = 'COMPLETED'
export const FAILED = 'FAILED'

type Status = typeof RUNNING | typeof COMPLETED | typeof FAILED

export { Status }



// WEBPACK FOOTER //
// ./src/types/checks.ts